export default __webpack_public_path__ + "static/media/customize-makeup.74f7e2b3.svg";